import React, { Suspense } from 'react';
import { Box } from '@gluestack-ui/themed';

import type { StackedBarChartChartProps } from './StackedBarChartChart';

const StackedBarChartChart = React.lazy(() => import('./StackedBarChartChart'));

export type StackedBarChartProps = StackedBarChartChartProps;

/**
 * Lazy-loaded feedback helpfulness chart (Recharts in a separate chunk).
 */
export function StackedBarChart({ testID, ...chartProps }: StackedBarChartProps) {
  return (
    <Suspense
      fallback={(
        <Box height={280} width="100%" testID={`${testID ?? 'helpfulness-chart'}-loading`} />
      )}
    >
      <StackedBarChartChart testID={testID} {...chartProps} />
    </Suspense>
  );
}
